import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('SellerRelationFilter', SellerRelationFilterData);

    function SellerRelationFilterData() {
        SellerRelationFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch
        };

        function SellerRelationFilter(sellerRelationFilterData) {
            if (!sellerRelationFilterData) {
                this.buildEmpty();
            } else {
                this.build(sellerRelationFilterData);
            }
        }

        return SellerRelationFilter;

        /////////////////////

        function buildEmpty() {
            this.buyer = null;
            this.principal = null;
            this.country = null;
            this.ladType = 'ALL';
            this.dematMode = 'ALL';
            this.onlyValidated = null;
            this.onlyAccepted = null;
        }

        function build(sellerRelationFilter) {
            this.buyer = sellerRelationFilter.buyer || null;
            this.principal = sellerRelationFilter.principal || null;
            this.country = sellerRelationFilter.country || null;
            this.ladType = sellerRelationFilter.ladType || null;
            this.dematMode = sellerRelationFilter.dematMode || null;
            this.onlyValidated = sellerRelationFilter.onlyValidated || null;
            this.onlyAccepted = sellerRelationFilter.onlyAccepted || null;
        }

        /**
         *
         */
        function preparBeforeSearch() {
            var clone = new SellerRelationFilter(this);

            clone.principalId = this.principal ? this.principal.id : null;
            clone.buyerId = this.buyer ? this.buyer.id : null;
            clone.countryCode = this.country ? this.country.code : null;

            if (clone.ladType === 'ALL') {
                clone.ladType = null;
            }
            if (clone.dematMode === 'ALL') {
                clone.dematMode = null;
            }

            return clone;
        }
    }
})();
